import * as React from "react";
import { Box, Container } from "@mui/material";
import { getBrandingColors } from "../brandingUtils";
import RegistrationBrandingHeader from "../RegistrationBrandingHeader";
import RegistrationFormCard from "../RegistrationFormCard";
import RegistrationPageFooter from "../RegistrationPageFooter";
import { layout, pageBgSx } from "../templateLayout";

export default function HeroTemplate({ page, event, user, onSubmit, submitting }) {
  const branding = page?.branding || {};
  const { primary } = getBrandingColors(branding);
  const heroImage = event?.coverImage || event?.image;

  return (
    <Box sx={pageBgSx()}>
      <Box
        sx={{
          position: "relative",
          minHeight: { xs: 220, sm: 280, md: 340 },
          backgroundImage: heroImage ? `url(${heroImage})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          bgcolor: primary,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background: `linear-gradient(180deg, ${primary}cc 0%, ${primary}ee 100%)`,
          }}
        />
        <Container
          maxWidth="md"
          sx={{
            position: "relative",
            zIndex: 1,
            px: layout.pagePx,
            py: { xs: 4, sm: 5, md: 6 },
          }}
        >
          <RegistrationBrandingHeader branding={branding} event={event} variant="light" />
        </Container>
      </Box>

      <Container
        maxWidth="md"
        sx={{
          px: layout.pagePx,
          py: layout.pagePy,
          mt: { xs: -2, sm: -3, md: -4 },
          position: "relative",
          zIndex: 2,
        }}
      >
        <RegistrationFormCard
          event={event}
          user={user}
          branding={branding}
          primaryColor={primary}
          onSubmit={onSubmit}
          submitting={submitting}
          showEventDetails
        />
        <RegistrationPageFooter branding={branding} />
      </Container>
    </Box>
  );
}
